import React, { useState, useEffect, useRef } from "react";
import { Field, Form, Formik } from "formik";
import { connect, useDispatch } from "react-redux";
import { bool, string } from "prop-types";
import { Col } from "react-bootstrap";
import { goBack, push } from "connected-react-router";
import * as Yup from "yup";
import { actions as onboardingActions, selectors as onboardingSelectors } from "reducers/onboarding";
import { actions as modalActions } from "reducers/modal";
import { selectors as enrollmentSelectors } from "reducers/enrollment";
import gaEventTracker, { events } from "util/gaEventTracker";
import Head from "pages/_components/Head";
import { ResponsiveHeader } from "pages/_components/header";

import Button from "pages/_components/Button";
import MainContainer from "pages/_components/MainContainer";
import Container from "pages/_components/Container";
import CustomText from "pages/_components/CustomText/CustomText";
import Checkbox from "pages/_components/Checkbox";
import * as i18nUtils from "util/i18n";
import Image from "pages/_components/Image";
import Stepper from "../_components/Stepper";
import ErrorPopup from "../_components/ErrorPopup";

const PAGE_ID = "StepScanDocument";
const FORM_ID = "onboarding.vu";

const StepScanDocumentBack = ({
    fetching,
    isMobile,
    errorValidateIdentity,
    scanDocumentInProgress,
    exchangeToken,
    onboardingWithInvitation,
    acceptRenaperTerms,
    identityValidationStarted,
    errorValidateIdentityPermissions,
    errorNewOperationVU,
}) => {
    const [error, setError] = useState("No podemos continuar con el proceso de onboarding.");

    const dispatch = useDispatch();
    const formRef = useRef(null);
    const [validateError, setvalidateError] = useState(false);

    useEffect(() => {
        console.log("StepScanDocument BACK Component");
        dispatch(onboardingActions.resetIdentityValidationProgress());
    }, []);

    useEffect(() => {
        if (onboardingWithInvitation === true) {
            gaEventTracker.triggerEvent(events.firmRegistry3);
        } else {
            gaEventTracker.triggerEvent(events.registry5);
        }
    }, [onboardingWithInvitation]);

    useEffect(() => {
        if (!fetching && errorValidateIdentity !== null) {
            if (errorValidateIdentityPermissions) {
                setvalidateError(true);
            } else {
                setError(errorValidateIdentity);
                dispatch(modalActions.modalShow());
            }
        }
    }, [fetching, errorValidateIdentity, errorValidateIdentityPermissions]);

    const onHeaderBack = () => {
        dispatch(goBack());
    };

    const handleClickButtonClose = () => {
        dispatch(modalActions.modalClose());
        if (errorNewOperationVU) {
            dispatch(push("/"));
        }
    };

    const onChangeCheckbox = (v) => {
        dispatch(onboardingActions.setAcceptRenaperTerms(v));
    };

    const goToTerms = () => {
        dispatch(push("/onboarding/stepScanDocumentTerms"));
    };

    const checkboxContainerStyle = {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    };

    const checkboxLabelStyle = {
        paddingLeft: "0px",
    };

    const formikProps = {
        validateOnChange: true,
        validateOnBlur: false,
        validationSchema: () => Yup.object().shape({}),
        onSubmit: () => {
            dispatch(onboardingActions.scanDocumentRequestBack(exchangeToken, onboardingWithInvitation === true));
        },
    };
    if (validateError) {
        return (
            <>
                {isMobile && (
                    <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} hideNavbarInMobile />
                )}
                <MainContainer>
                    {!isMobile && (
                        <Container>
                            <Col xs={12} md={8} mdOffset={2}>
                                <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />
                            </Col>
                        </Container>
                    )}
                    <Col xs={12} md={8} mdOffset={2}>
                        <h1 className="text-center">
                            <CustomText text={i18nUtils.get("", "Permiso de foto y video rechazado")} />
                        </h1>
                    </Col>
                    <div className="illustration text-center">
                        <Image src="figma/illustrations/onboarding13.svg" className="svg-image logo" />
                    </div>
                    {/* <Col xs={12} md={8} mdOffset={2}>
                        <div className="bienvenida-alta-persona">Ilustración</div>
                    </Col> */}
                    <div className="box box-border-soft">
                        {" "}
                        <CustomText text={i18nUtils.get("", error)} />
                        <>
                            <br />
                            <br />
                            <CustomText
                                text={i18nUtils.get(
                                    "",
                                    "Se necesita aceptar permisos para continuar con la navegación.",
                                )}
                            />
                        </>
                    </div>

                    <div className="form-actions">
                        <Button
                            bsStyle="primary"
                            label="global.agreed"
                            // defaultLabelText="Entendido"
                            loading={false}
                            onClick={() => {
                                setvalidateError(false);
                            }}
                        />
                    </div>
                </MainContainer>
            </>
        );
    }
    return (
        <>
            {!isMobile && (
                <Container>
                    <Col xs={12} md={8} mdOffset={2}>
                        <Head title="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />
                    </Col>
                </Container>
            )}
            {isMobile && !scanDocumentInProgress && (
                <ResponsiveHeader ticket id="onboarding.noUser.title" onBack={isMobile && onHeaderBack} />
            )}
            {isMobile && (
                <MainContainer showLoader={scanDocumentInProgress}>
                    <Stepper isMobile={isMobile} page={PAGE_ID} />
                    <Formik {...formikProps} ref={formRef}>
                        {() => (
                            <Form className="above-the-fold" ref={formRef}>
                                <h1 className="text-center" style={{ textAlign: "left" }}>
                                    <CustomText text={i18nUtils.get("", "Validación del dorso de DNI")} />
                                </h1>
                                <div className="box box-border-soft three-step-box">
                                    <div className="paso1">
                                        <h3>
                                            <CustomText text={i18nUtils.get("", "Captura de dorso del DNI")} />
                                        </h3>
                                        <CustomText
                                            text={i18nUtils.get("", "Tené a mano tu DNI para poder fotografiarlo.")}
                                        />
                                    </div>
                                    <hr className="dotted my-6" />
                                    <div className="paso2">
                                        <h3>
                                            <CustomText text={i18nUtils.get("", "Reconocimiento facial")} />
                                        </h3>
                                    </div>
                                </div>
                                <div className="form-actions">
                                    <Button
                                        bsStyle="primary"
                                        defaultLabelText="Continuar"
                                        type="submit"
                                        block
                                        loading={fetching}
                                        disabled={!acceptRenaperTerms || errorNewOperationVU}
                                    />
                                </div>
                            </Form>
                        )}
                    </Formik>
                </MainContainer>
            )}
            <ErrorPopup error={error} handleClick={handleClickButtonClose} />
        </>
    );
};

StepScanDocumentBack.propTypes = {
    fetching: bool.isRequired,
    isMobile: bool.isRequired,
    onboardingWithInvitation: bool.isRequired,
    acceptRenaperTerms: bool.isRequired,
    identityValidationStarted: bool.isRequired,
    exchangeToken: string.isRequired,
    errorValidateIdentity: string,
    errorValidateIdentityPermissions: bool,
    scanDocumentInProgress: bool,
    errorNewOperationVU: bool.isRequired,
};

StepScanDocumentBack.defaultProps = {
    errorValidateIdentity: null,
    errorValidateIdentityPermissions: null,
    scanDocumentInProgress: false,
};

const mapStateToProps = (state) => ({
    fetching: onboardingSelectors.getFetching(state),
    exchangeToken: enrollmentSelectors.getExchangeToken(state),
    errorValidateIdentity: onboardingSelectors.getErrorValidateIdentity(state),
    errorValidateIdentityPermissions: onboardingSelectors.geterrorValidateIdentityPermissions(state),
    scanDocumentInProgress: onboardingSelectors.getScanDocumentInProgress(state),
    onboardingWithInvitation: onboardingSelectors.getOnboardingWithInvitation(state),
    acceptRenaperTerms: onboardingSelectors.getAcceptRenaperTerms(state),
    identityValidationStarted: onboardingSelectors.getIdentityValidationStarted(state),
    errorNewOperationVU: onboardingSelectors.getErrorNewOperationVU(state),
});

export default connect(mapStateToProps)(StepScanDocumentBack);
